import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

/**
 * Guards
 */
import { AuthGuard } from './guards/auth.guard';
import { RoleGuard } from './guards/role.guard';

/**
 * Components
 */
import { LoginComponent } from './components/login/login.component';
import { EventComponent } from './components/event/event.component';
import { EventTicketsComponent } from './components/event-tickets/event-tickets.component';
import { SelectCashRegisterComponent } from './components/select-cash-register/select-cash-register.component';
import { CashRegisterGuard } from './guards/cash-register.guard';
import { CashRegisterReportComponent } from './components/cash-register-report/cash-register-report.component';
import { CashRegisterReportDetailComponent } from './components/cash-register-report-detail/cash-register-report-detail.component';
import { SeatMapComponent } from './components/seat-map/seat-map.component';
import { EventsComponent } from './pages/events/events.component';
import { EventSaleComponent } from './pages/event-sale/event-sale.component';
import { RefundsComponent } from './pages/refunds/refunds.component';
import { RefundDetailComponent } from './pages/refund-detail/refund-detail.component';
import { ReservasListComponent } from './pages/reservas/reservas-list.component';
import { ReservaDetailComponent } from './pages/reservas/reserva-detail.component';
import { PassesComponent } from './pages/passes/passes.component';
import { PassSaleComponent } from './pages/pass-sale/pass-sale.component';
import { PassSaleBulkComponent } from './pages/pass-sale-bulk/pass-sale-bulk.component';

const routes: Routes = [
  {
    path: '',
    component: LoginComponent
  },
  { path: 'login/:business/:token', component: LoginComponent },
  {
    path: 'select-cashregister',
    component: SelectCashRegisterComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'event/:idEvent',
    component: EventComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'cash-register-report',
    component: CashRegisterReportComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'cash-register-report/:idSession',
    component: CashRegisterReportDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'event/tickets/:idEvent',
    component: EventTicketsComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'event/seatmap/:idEvent',
    component: SeatMapComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'home',
    component: EventsComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'event-sale/:idEvent',
    component: EventSaleComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'refunds',
    component: RefundsComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'refunds/:idRefund',
    component: RefundDetailComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  // --- Rutas de Reservas (solo admin/superadmin) ---
  {
    path: 'reservas',
    component: ReservasListComponent,
    canActivate: [AuthGuard, CashRegisterGuard, RoleGuard],
  },
  {
    path: 'reservas/:id',
    component: ReservaDetailComponent,
    canActivate: [AuthGuard, CashRegisterGuard, RoleGuard],
  },
  {
    path: 'passes',
    component: PassesComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'pass-sale/:idPass',
    component: PassSaleComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'pass-sale/:idPass/event/:idEvent',
    component: PassSaleComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'pass-sale-bulk/:idPass/:quantity',
    component: PassSaleBulkComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
  {
    path: 'pass-sale-bulk/:idPass/:quantity/event/:idEvent',
    component: PassSaleBulkComponent,
    canActivate: [AuthGuard, CashRegisterGuard],
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
